const hiraganaList = require("./hiragana_list.json");

const replaceCodeWithHiragana = (nameCodes) => {
    let string = "";

    for (let i = 0; i < nameCodes.length; i++) {
        const code = nameCodes[i];
        const hiragana = hiraganaList.find((h) => h.key === code);
        if (hiragana) {
            string += hiragana.value;
        }
    }

    return string;
};

const getCodeFromHiraganaString = (hiragana) => {
    let keyArray = [];
    let cleanedString = replaceSpecialCharacters(hiragana);
    let splitHiragana = cleanedString.split("");

    for (let i = 0; i < splitHiragana.length; i++) {
        const hiragana = splitHiragana[i];
        const code = hiraganaList.find((h) => h.value === hiragana);
        if (code) {
            keyArray.push(code.key);
        }
    }

    return keyArray;
};

const replaceSpecialCharacters = (string) => {
    if (string.length > 0) {
        string = string

            //replace -, —, or – with ー
            .replace(/[-—]/g, "ー")

            // replace ? with ？
            .replace(/\?/g, "？")

            // replace ! with ！
            .replace(/!/g, "！")

            // replace ~ with ～
            .replace(/~/g, "～");
    }

    return string;
};

export {
    hiraganaList,
    replaceCodeWithHiragana,
    getCodeFromHiraganaString,
    replaceSpecialCharacters,
};
